import { useNavigate, useParams } from "react-router-dom"
import Helpers from "../../../Helpers/Helpers"
import { useEffect, useState } from "react"
import Notification from '../../../Helpers/Notification'
import Breadcrum from "../../components/Breadcrum"
import { useDispatch, useSelector } from "react-redux"
import { addToCart } from "../../features/cart/cartSlice"
import { useAuth } from "../../context/AuthContext"

// Helper function to format long description
const formatLongDescription = (text) => {
    if (!text) return '';
    
    // Split the text into sections based on double line breaks
    const sections = text.split('\r\n\r\n').filter(section => section.trim());
    
    return sections.map((section, index) => {
        const lines = section.split('\r\n').map(line => {
            // Remove bullet points and trim
            const cleanLine = line.replace(/^•\t/, '').trim();
            // If original line had a bullet point, wrap in li
            return line.startsWith('•') ? 
                `<li>${cleanLine}</li>` : 
                `<p className="section-title">${cleanLine}</p>`;
        }).join('');
        
        // Wrap bullet points in ul
        return lines.includes('<li>') ? 
            `<div key=${index}><ul className="feature-list">${lines}</ul></div>` :
            `<div key=${index}>${lines}</div>`;
    }).join('');
};

const ShopSingleComponent = ({ title }) => {

    const { id } = useParams() // Get product ID from the URL
    const helpers = Helpers()
    const navigate = useNavigate()
    const [loading, setLoading] = useState(true)
    const [product, setProduct] = useState(null) // Store the product data
    const [quantity, setQuantity] = useState(1) // Add quantity state
    const dispatch = useDispatch()
    const cartItems = useSelector(state => state.cart.items)
    const inCart = cartItems.some(item=>item.id===id)
    const { isAuthenticated } = useAuth()

    // Function to handle quantity increment
    const incrementQuantity = () => {
        if (quantity < 100) { // Max limit as per the input max attribute
            setQuantity(quantity + 1)
        }
    }

    // Function to handle quantity decrement
    const decrementQuantity = () => {
        if (quantity > 0) { // Minimum 0 as requested
            setQuantity(quantity - 1)
        }
    }

    // Function to handle direct input change
    const handleQuantityChange = (e) => {
        const value = parseInt(e.target.value) || 0
        if (value >= 0 && value <= 100) {
            setQuantity(value)
        }
    }


    const handleAddToCart = () => {
        if(!isAuthenticated){
            navigate('/login')
            return
        }
        if (quantity === 0) {
            Notification('error', 'Please select a quantity greater than 0')
            return
        }

        // Add quantity to the product before adding to cart
        const productWithQuantity = { ...product, quantity }
        dispatch(addToCart(productWithQuantity))
        
        Notification('success', `${quantity} item(s) added to cart successfully!`)
    }


    useEffect(() => {
        // Fetch product details for pre-populating the form
        const fetchProduct = async () => {
            try {
                const response = await helpers.httpRequest(`/product/${id}?populate=true`, 'GET')
                if (response.status === 'success') {
                    setProduct(response.data)
                } else {
                    Notification('error', 'Error fetching product data')
                    navigate('/notfound')
                }
            } catch (error) {
                console.error('Error fetching product:', error)
                Notification('error', 'Error fetching product data')
            }
        }

        // Show loader until both product and categories are fetched
        Promise.all([fetchProduct()]).finally(() => setLoading(false))
    }, [id])
    return (
        <>
            <Breadcrum title={title} />

            <section className="as_shopsingle_wrapper as_padderBottom80 as_padderTop80">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 col-md-12 col-sm-12">
                            <div className="as_shopsingle_slider">
                                {/* <div className="as_shopsingle_nav">
                                    <div className="as_prod_img">
                                        <img alt="Product image" className="img-responsive" src={product?.full_image} />
                                    </div>
                        
                                </div> */}
                                <div className="as_shopsingle_for">
                                    <div className="as_prod_img">
                                        <img alt="Product image" className="img-responsive" src={product?.main_image ? `${process.env.REACT_APP_API_URL}/uploads/products/${product.main_image.url}` : product?.full_image} />
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-12 col-sm-12">
                            <div className="as_product_description">
                                <h3 className="as_subheading as_margin0 as_padderBottom10">
                                    {product?.title}
                                </h3>
                                <h2 className="as_price">
                                    ₹ {product?.price}
                                    <del>
                                        ₹ {product?.del_price}
                                    </del>
                                    <span className="as_off as_btn">
                                        {product?.del_price && product?.price ? 
                                            `${Math.round(((product.del_price - product.price) / product.del_price) * 100)}% Off` 
                                            : '0% Off'
                                        }
                                    </span>
                                </h2>
                                <div className="product_rating as_padderBottom10">
                                    <span className="rating_star">
                                        <img alt="Rating stars" src="/assets/images/rating.png" />
                                        <span>
                                            {/* (20 customer review) */}
                                        </span>
                                    </span>
                                    <span className="ref_number as_font14 ">
                                        Category: {product?.category?.name}
                                    </span>
                                </div>
                                <p className="as_padderBottom10">
                                    {product?.description}
                                </p>
                                <div className="prod_detail">
                                    <div className="prod_quantity as_padderBottom40">
                                        Quantity :
                                        <div className="quantity">
                                            <button className="qty_button minus" type="button" onClick={decrementQuantity}>
                                                <img alt="Decrease quantity" src="/assets/images/svg/arrow_down.svg" />
                                            </button>
                                            <input className="input-text form-control qty text" id="quantity_6041ce9eca5d6" inputMode="numeric" max="100" min="0" name="quantity" step="1" title="Qty" type="number" value={quantity} onChange={handleQuantityChange} />
                                            <button className="qty_button plus" type="button" onClick={incrementQuantity}>
                                                <img alt="Increase quantity" src="/assets/images/svg/arrow_up.svg" />
                                            </button>
                                        </div>
                                    </div>
                                    {inCart ? (
                                      <button className="buy_btn as_btn" type="button" onClick={()=>navigate('/checkout')}>
                                        <span><img alt="Cart" src="/assets/images/svg/cart.svg" /></span>
                                        Go to Cart
                                      </button>
                                    ) : (
                                      <button onClick={handleAddToCart} className="buy_btn as_btn" type="button">
                                        <span><img alt="Shopping cart" src="/assets/images/svg/cart.svg" /></span>
                                        Add to Cart
                                      </button>
                                    )}
                                    {/* <a className="ad_wishlist" href="#">
                                        <img alt="" src="/assets/images/svg/wishlist1.svg" />
                                    </a>
                                    <a className="ad_compare" href="#">
                                        <img alt="" src="/assets/images/svg/compare1.svg" />
                                    </a> */}
                                </div>
                                {/* <div className="as_share_box as_padderTop30">
                                    <ul>
                                        <li>
                                            <a href="">

                                            </a>
                                        </li>
                                        <li>
                                            <a href="">

                                            </a>
                                        </li>
                                        <li>
                                            <a href="">

                                            </a>
                                        </li>
                                    </ul>
                                </div> */}
                            </div>
                        </div>
                        <div className="col-lg-12 col-md-12">
                            <div className="as_tab_wrapper as_padderTop80">
                                <ul className="nav nav-tabs" id="myTab" role="tablist">
                                    <li className="nav-item" role="presentation">
                                        <button aria-controls="today" aria-selected="true" className="nav-link active" data-bs-target="#today" data-bs-toggle="tab" id="Today" role="tab" type="button">
                                            Descriptions
                                        </button>
                                    </li>

                                    <li className="nav-item" role="presentation">
                                        <button aria-controls="tomorrow" aria-selected="false" className="nav-link" data-bs-target="#tomorrow" data-bs-toggle="tab" id="Tomorrow" role="tab" type="button">
                                            Long Description
                                        </button>
                                    </li>
                                </ul>
                                <div className="tab-content as_padderTop60" id="myTabContent">
                                    <div aria-labelledby="Today" className="tab-pane fade show active" id="today" role="tabpanel">
                                        {product?.description}
                                    </div>

                                    <div aria-labelledby="Tomorrow" className="tab-pane fade" id="tomorrow" role="tabpanel">
                                        <h3 className="as_subheading as_orange as_margin0 as_padderBottom10">
                                            Long Description
                                        </h3>
                                        <div 
                                            className="formatted-description"
                                            dangerouslySetInnerHTML={{ 
                                                __html: formatLongDescription(product?.long_description) 
                                            }}
                                        />
                                        <style>{`
                                            .formatted-description {
                                                font-size: 14px;
                                                line-height: 1.6;
                                            }
                                            .formatted-description .section-title {
                                                font-weight: bold;
                                                margin-bottom: 15px;
                                                color: #333;
                                            }
                                            .formatted-description .feature-list {
                                                list-style-type: disc;
                                                padding-left: 20px;
                                                margin-bottom: 20px;
                                            }
                                            .formatted-description .feature-list li {
                                                margin-bottom: 8px;
                                            }
                                        `}</style>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default ShopSingleComponent
